// RBAC — tier-based capabilities. 7 default roles + legacy aliases.
// can(role, permission) is the single source of truth used across the app.
export const ROLE_LABEL = {
  owner: "Ägare", chef: "Restaurangchef", shift_leader: "Skiftledare",
  kitchen: "Kök", service: "Servering", prep: "Prep", cleaning: "Disk & Städ",
  // legacy aliases (Step 1/2 data)
  agare: "Ägare", skiftledare: "Skiftledare", personal: "Personal", styrelse: "Styrelse",
};

// Job role -> capability tier (1 staff .. 4 owner). 0 = board (read-only).
const TIER = {
  owner: 4, agare: 4,
  chef: 3,
  shift_leader: 2, skiftledare: 2,
  kitchen: 1, service: 1, prep: 1, cleaning: 1, personal: 1, staff: 1,
  styrelse: 0,
};

// Departments a job-role staff member defaults to.
export const ROLE_DEPARTMENT = { kitchen: "kok", service: "servering", prep: "prep", cleaning: "stad" };

const T1 = [
  "task.read", "task.complete", "checklist.read", "checklist.complete",
  "manual.read", "incident.create", "incident.read", "report.read",
  "ai.use", "search.use", "notification.read", "comment.create", "attachment.create",
];
const T2 = ["task.create", "task.assign", "task.update", "checklist.create", "checklist.update", "manual.create", "manual.update", "report.create", "incident.update"];
const T3 = ["task.delete", "checklist.delete", "manual.delete", "incident.delete", "department.manage", "automation.manage", "ai.configure", "user.read", "audit.read", "analytics.read"];
const T4 = ["user.manage", "role.manage", "restaurant.manage", "organization.read", "foodcost.access", "dashboard.access"];

const TIER_CAPS = {
  1: new Set(T1),
  2: new Set([...T1, ...T2]),
  3: new Set([...T1, ...T2, ...T3]),
  4: new Set([...T1, ...T2, ...T3, ...T4]),
};
const BOARD = new Set(["analytics.read", "audit.read", "report.read", "search.use", "ai.use", "notification.read", "task.read", "incident.read", "manual.read"]);

export function tierOf(role) { return TIER[role] ?? 0; }
export function hasLevel(role, min) { return tierOf(role) >= tierOf(min); }

export function can(role, permission) {
  if (!role) return false;
  const t = TIER[role];
  if (t === 0 || t === undefined) return BOARD.has(permission);
  return TIER_CAPS[t].has(permission);
}

// Roles selectable in the admin UI.
export const ASSIGNABLE_ROLES = [
  { key: "owner", label: "Ägare" },
  { key: "chef", label: "Restaurangchef" },
  { key: "shift_leader", label: "Skiftledare" },
  { key: "kitchen", label: "Kök" },
  { key: "service", label: "Servering" },
  { key: "prep", label: "Prep" },
  { key: "cleaning", label: "Disk & Städ" },
];
